import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  margin: 0 auto;
  background-color: #222;
  align-self: center;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: auto;
  z-index: 1001;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  max-width: 1440px;
  height: auto;

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

export const Description = styled.div`
  width: auto;
  height: 100%;
  justify-content: center;
  text-align: justify;
  padding: 1.2rem;
  font-size: var(--font-text-size);
  color: #fff;

  p {
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      display: inline-flex;
      color: var(--color-primary);
      cursor: pointer;

      &:hover {
        transition: var(--transition);
        color: var(--color-primary-dark);
      }
    }
  }
`;

export const ButtonContainer = styled.div`
  width: auto;
  min-width: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;

  button {
    padding: 0.5rem 2rem;
    background-color: var(--color-primary);
    color: #fff;
    border-radius: var(--border-radius);
    transition: var(--transition);
    border: none;
    cursor: pointer;

    &:hover {
      background-color: var(--color-primary-dark);
    }
  }
`;
